<mat-card class="panel-card no-shadow">
  <mat-card-header class="panel-header">
    <mat-card-title class="card-title">{{'workspace_tab3' | translate}}</mat-card-title>
    <div class="panel-toolbar">
      <div class="select-all">
        <input class="form-check-input" type="checkbox" id="organizeTeamsAllMembers"
               [checked]="allChecked" [disabled]="rows.length === 0" (change)="onToggleAll($event)">
        <label for="organizeTeamsAllMembers">{{'step51_select' | translate}}</label>
      </div>

      <div class="search-input-container">
        <span class="p-input-icon-left search-input-wrapper">
          <i class="bi bi-search search-icon" *ngIf="!searching"></i>
          <span class="spinner-border spinner-border-sm text-primary search-spinner" role="status" *ngIf="searching"></span>
          <input id="searchMember" class="search-or-invite-input" type="text" pInputText autocomplete="off"
                 [ngModel]="searchValue" (ngModelChange)="searchChange.emit($event)"
                 placeholder="{{'step51_search' | translate}}" (keyup.enter)="onSearchEnter()">
        </span>
        <button type="button" *ngIf="showInvite" class="invite-new-email" (click)="invite.emit()">
          <i class="bi bi-send send-icon"></i>
          <b>{{'organizeteam_invite' | translate}}</b>
          <span class="invite-email">{{searchValue}}</span>
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="panel-content">
    <div cdkDropList
         id="workspace-members"
         class="members-list"
         [cdkDropListData]="rows"
         [cdkDropListConnectedTo]="['leaders', 'members']"
         [cdkDropListDisabled]="dragDisabled"
         (cdkDropListDropped)="onDropped($event)"
         (scroll)="onScroll($event)">
      <div *ngFor="let row of rows; trackBy: trackByUser"
           cdkDrag
           [cdkDragData]="row.member"
           class="workspace-member"
           [class.workspace-member--assigned]="row.assigned"
           (click)="toggleMember.emit(row.member.userUuid)">
        <input class="form-check-input" type="checkbox" [checked]="row.checked" [attr.aria-label]="row.member.label"
               (click)="$event.stopPropagation()" (change)="toggleMember.emit(row.member.userUuid)">
        <img class="user-picture" [src]="row.member.avatarUrl || defaultAvatar" alt="">
        <p class="member-label" [title]="row.member.label">{{row.member.label}}</p>
        <span class="member-status" [class.member-status--assigned]="row.assigned">
          {{(row.assigned ? 'step51_member_status2' : 'step51_member_status1') | translate}}
        </span>
      </div>

      <div *ngIf="rows.length === 0 && !searchValue" class="no-workspace-member">
        <p>{{'manage_all_assigned' | translate}}</p>
        <p>{{'manage_missing' | translate}}</p>
      </div>
      <p *ngIf="searching" class="search-state">{{'organizeteam_searching' | translate}}</p>
      <p *ngIf="noResults && !searching" class="search-state">{{'organizeteam_no_members_found' | translate}}</p>
    </div>
    <div class="members-loading" *ngIf="loadingMembers">
      <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
    </div>
  </mat-card-content>
</mat-card>
